import {Component, input} from '@angular/core';
import {TabItems, TabsInterface} from '../layout/interface/tabs.interface';

 @Component({
  selector: 'quiz-footer',
  imports: [],
  templateUrl: './footer.html',
  styleUrl: './footer.scss',
})
export class Footer {
   public tabs = input<TabsInterface | undefined>();
  public yearsNow =  new Date().getFullYear()
}
